<template>
  <CockpitDialog
    title="应急物资详情"
    left="630px"
    width="890px"
    height="500px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="w-full h-full overflow-auto" v-loading="loading">
      <div v-for="(row, ind) in tableData" :key="ind">
        <div
          class="h-28px bg-[#0F6B73] mb-10px flex items-center cursor-pointer"
          @click="showCollapse(ind)"
        >
          <span class="mx-8px" v-if="isShowList[ind]">
            <img src="../../../../assets/images/arrow-tri-down.png" alt="" />
          </span>
          <span class="mx-8px" v-else>
            <img src="../../../../assets/images/arrow-tri-right.png" alt="" />
          </span>
          {{ row | filterName }}物质详情
        </div>
        <div v-show="isShowList[ind]">
          <div class="border-l-3 border-color-primary pl-10px text-18px mb-5px">
            {{ row | filterName }}
          </div>
          <el-divider></el-divider>
          <el-row :gutter="15" class="w-full h-full overflow-auto">
            <el-col v-for="(item, index) in row" :key="index" :span="8">
              <div class="h-30px leading-30px flex justify-start items-center">
                <div class="inline-block w-100px">{{ item.label }}：</div>
                <el-tooltip :content="item.value + ''">
                  <div class="inline-block flex-1 truncate">
                    {{ item.value }}
                  </div>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { SuppliesManagementApi } from '@wiz-api/emergency-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const suppliesManagementApi = new SuppliesManagementApi()

export default {
  name: 'emergenc-matte-dialog',
  filters: {
    filterName(row) {
      return row.find((item) => {
        return item.field === 'name'
      })?.value
    },
  },
  data() {
    return {
      isShowList: [],
      loading: false,
      formConfig: [
        {
          label: '物资编号',
          field: 'codeStr',
          value: '',
        },
        {
          label: '物资名称',
          field: 'name',
          value: '',
        },
        {
          label: '责任部门',
          field: 'orgName',
          value: '',
        },
        {
          label: '出厂编号',
          field: 'no',
          value: '',
        },
        {
          label: '出厂日期',
          field: 'productionDate',
          value: '',
        },
        {
          label: '有效期',
          field: 'expirationDate',
          value: '',
        },
        {
          label: '物资点位',
          field: 'suppliesSiteName',
          value: '',
        },
        {
          label: '检验负责人',
          field: 'responsiblePersonName',
          value: '',
        },
        {
          label: '初次检验日期',
          field: 'initialInspectionDate',
          value: '',
        },
      ],
      tableData: [],
    }
  },
  components: {
    CockpitDialog,
  },
  props: {
    propData: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    'propData.suppliesSite': {
      handler(newVal) {
        this.getDetail(newVal)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showCollapse(index) {
      const list = JSON.parse(JSON.stringify(this.isShowList))
      list[index] = !list[index]
      this.isShowList = list
    },
    /**
     * 获取详情
     */
    async getDetail(id) {
      this.loading = true
      // suppliesSite
      const [err, res] = await suppliesManagementApi.getList({
        skipCount: 0,
        maxResultCount: 999,
        suppliesSite: id,
      })
      if (!err) {
        const tableData = []
        res.items.forEach((row) => {
          this.formConfig.forEach((item) => {
            const keys = Object.keys(row)
            if (keys.includes(item.field)) {
              if (
                ['productionDate', 'expirationDate', 'initialInspectionDate'].includes(item.field)
              ) {
                item.value = row[item.field]
                  ? dayjs(row[item.field]).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              } else {
                item.value = row[item.field]
              }
            }
          })
          tableData.push(JSON.parse(JSON.stringify(this.formConfig)))
        })
        this.tableData = tableData
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-divider--horizontal {
  margin: 0;
  margin-bottom: 10px;
  opacity: 0.1;
}
</style>
